import { Appointment } from './AppointmentModels';
import { FileModel } from './FileModels';

export class AppointmentLetterModel extends FileModel {
  constructor(id: string) {
    super();
    this.appointmentId = id;
  }
  appointmentId?: string;
  appointment?: Appointment;
  title?: string;
  pageCount?: number;
  comments?: string;
}

export class AppointmentIdGridSearchModel {
  constructor(id: string) {
    this.appointmentId = id;
  }

  appointmentId?: string;
  showHiddenFiles?: boolean;
}

export enum AppointmentLetterModal {
  Attachments = 'attachmentsLetter'
}
